// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/Frame.css
// module id = 2017
// module chunks = 2